export default __webpack_public_path__ + "static/media/LAS0920.34I-41363_-24663_0.4bb38408.jpg";